import React from "react";
import { Route, Switch } from "react-router-dom";

import NutrientsCertifiedComponent from "../../components/page/nutrients/nutrientsCertified/NutrientsCertifiedComponent";
import NutrientsCertifiedCreateComponent from "../../components/page/nutrients/nutrientsCertified/NutrientsCertifiedCreateComponent";
import NutrientsCertifiedNutritionComponent from "../../components/page/nutrients/nutrientsCertified/NutrientsCertifiedNutritionComponent";
import NutrientsRequestComponent from "../../components/page/nutrients/nutrientsRequest/NutrientsRequestComponent";
import NutrientsRequestCreateComponent from "../../components/page/nutrients/nutrientsRequest/NutrientsRequestCreateComponent";
import NutrientsRequestNutritionComponent from "../../components/page/nutrients/nutrientsRequest/NutrientsRequestNutritionComponent";

const NutrientsPage = () => {
  return (
    <div className="contentPage" style={{ margin: 24 }}>
      <Switch>
        {/** nutrients **/}
        <Route
          exact
          path="/nutrients/view/certified"
          component={NutrientsCertifiedComponent}
        />
        <Route
          exact
          path="/nutrients/view/request"
          component={NutrientsRequestComponent}
        />
        {/** nutrientsNutrition **/}
        <Route
          path="/nutrients/view/certified/:id"
          component={NutrientsCertifiedNutritionComponent}
        />
        <Route
          path="/nutrients/view/request/:id"
          component={NutrientsRequestNutritionComponent}
        />
        {/** nutrientsCreate **/}
        <Route
          path="/nutrients/certified/create"
          component={NutrientsCertifiedCreateComponent}
        />
        <Route
          path="/nutrients/request/create"
          component={NutrientsRequestCreateComponent}
        />
      </Switch>
    </div>
  );
};

export default NutrientsPage;
